function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.parse-int.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useToasts } from '@applyboard/crystal-ui';
import { useCurrentUser, useEventTracker, verifyRole } from '@applyboard/ui-utils';
import { useEmailValidator } from "../../data/emailValidator";
import { useAttachStudentPassport } from "../../data/passport";
import { useCheckStudentDuplicate } from "../../data/studentDuplicateCheck";
import { useAddStudent, useEditStudent } from "../../data/students/students";
import { DuplicateStudentWarningDialog } from "../..";
import { SuspendedRPDialog } from "../SuspendedRPDialog";
import { AddNewStudentDialog } from "./AddNewStudentDialog";
import { FormWrapper, formatNewStudentData, useResetForm, useSetFieldValues } from "./AddNewStudentDialogForm";
import { DEFAULT_FORM_VALUES, SUSPENDED_RP_DIALOG_INSTRUCTION, SUSPENDED_RP_DIALOG_NOTICE_MESSAGE, SUSPENDED_RP_DIALOG_TITLE, StudentReferralTool } from "./const";
import { useApiDropdownList } from "./hooks";
import { getUserAgentInformation, publishAddNewStudentEvent, trimFormData } from "./util";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var LEAD_STATUS_OPTIONS = [{
  label: 'New Lead',
  value: 'new_lead'
}, {
  label: 'Follow up',
  value: 'follow_up'
}, {
  label: 'Ready to Apply',
  value: 'ready_to_apply'
}];
export function AddNewStudentModal(props) {
  var _currentUser$relation, _currentUser$relation2, _currentUser$relation3;
  var history = useHistory();
  var _useCurrentUser = useCurrentUser(),
    _useCurrentUser2 = _slicedToArray(_useCurrentUser, 1),
    currentUser = _useCurrentUser2[0];
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    duplicateStudents = _useState2[0],
    setDuplicateStudents = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    submittedFormValues = _useState4[0],
    setSubmittedFormValues = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    hasFormError = _useState6[0],
    setHasFormError = _useState6[1];
  var _useCheckStudentDupli = useCheckStudentDuplicate(),
    checkStudentDuplicate = _useCheckStudentDupli.checkStudentDuplicate;
  var _useAddStudent = useAddStudent(),
    addStudent = _useAddStudent.addStudent,
    isAddingStudent = _useAddStudent.isAddingStudent;
  var _useEditStudent = useEditStudent(),
    editStudent = _useEditStudent.editStudent,
    isEditingStudent = _useEditStudent.isEditingStudent;
  var _useEmailValidator = useEmailValidator(),
    validateEmail = _useEmailValidator.validateEmail,
    isValidatingEmail = _useEmailValidator.isValidatingEmail;
  var _useAttachStudentPass = useAttachStudentPassport(),
    uploadStudentPassport = _useAttachStudentPass.uploadStudentPassport,
    isUploadingStudentPassport = _useAttachStudentPass.isUploadingStudentPassport;
  var isSubmittingStudentProfile = isAddingStudent || isEditingStudent || isUploadingStudentPassport || isValidatingEmail;
  var messageDispatch = useToasts();
  var isRp = verifyRole.isRp(currentUser);
  var agencyId = currentUser === null || currentUser === void 0 ? void 0 : (_currentUser$relation = currentUser.relationships) === null || _currentUser$relation === void 0 ? void 0 : (_currentUser$relation2 = _currentUser$relation.agent_information) === null || _currentUser$relation2 === void 0 ? void 0 : (_currentUser$relation3 = _currentUser$relation2.data) === null || _currentUser$relation3 === void 0 ? void 0 : _currentUser$relation3.id;
  var clearDuplicateStudentsList = function clearDuplicateStudentsList() {
    return setDuplicateStudents(null);
  };
  var handleAddStudent = function handleAddStudent(data) {
    var formData = formatNewStudentData(data);
    var trimmedFormData = trimFormData(formData);
    addStudent({
      didStudentConsent: trimmedFormData.didStudentConsent,
      blocked: trimmedFormData.blocked,
      email: trimmedFormData.email,
      agencyId: agencyId,
      leadStatus: trimmedFormData.leadStatus,
      leadSource: trimmedFormData.leadSource,
      customLeadSource: trimmedFormData.customLeadSource,
      countryOfInterest: trimmedFormData.countryOfInterest,
      serviceOfInterest: trimmedFormData.servicesOfInterest.map(function (serviceOfInterestId) {
        return Number.parseInt(serviceOfInterestId);
      }),
      referralTool: StudentReferralTool.AddNewStudentModal
    }, {
      onSuccess: function onSuccess(newStudent) {
        publishAddNewStudentEvent({
          formData: trimmedFormData,
          trackEvent: trackEvent
        });
        editStudent({
          birthDate: formData.birthDate,
          country: formData.countryOfCitizenship,
          gender: formData.gender,
          id: newStudent.id,
          nameFamily: formData.lastName,
          nameGiven: formData.firstName,
          nameMiddle: formData.middleName,
          phoneNumber: formData.phoneNumber,
          passportNumber: formData.passportNumber,
          passportExpiryDate: formData.passportExpiryDate.length ? formData.passportExpiryDate : undefined
        }, {
          onSuccess: function onSuccess() {
            var _data$passportFile;
            if ((_data$passportFile = data.passportFile) !== null && _data$passportFile !== void 0 && _data$passportFile.length) {
              uploadStudentPassport({
                file: data.passportFile[0].file,
                studentDocumentId: newStudent.studentPassportDocumentId
              }, {
                onSuccess: function onSuccess() {
                  messageDispatch.positive('Successfully Added Student');
                  props.setShowModal(false);
                  if (props.onCreatedStudent) {
                    props.onCreatedStudent(newStudent);
                  } else {
                    history.replace("/students/".concat(newStudent.id));
                  }
                },
                onError: function onError() {
                  messageDispatch.warning("Student is created but we were unable to attach the passport.\n                Please edit the profile and update the missing info.");
                  history.replace("/students/".concat(newStudent.id));
                }
              });
            } else {
              messageDispatch.positive('Successfully Added Student');
              props.setShowModal(false);
              if (props.onCreatedStudent) {
                props.onCreatedStudent(newStudent);
              } else {
                history.replace("/students/".concat(newStudent.id));
              }
            }
          },
          onError: function onError() {
            publishAddNewStudentEvent({
              formData: trimmedFormData,
              errorType: 'api_update',
              trackEvent: trackEvent
            });
            messageDispatch.warning("Student is created but some details could not be saved.\n                Please edit the profile and update the missing info.");
            history.replace("/students/".concat(newStudent.id));
          }
        });
      },
      onError: function onError(error) {
        var _apiError$body;
        var apiError = error;
        if (apiError !== null && apiError !== void 0 && (_apiError$body = apiError.body) !== null && _apiError$body !== void 0 && _apiError$body.errors) {
          var _apiError$body2;
          messageDispatch.negative(new Error(apiError === null || apiError === void 0 ? void 0 : (_apiError$body2 = apiError.body) === null || _apiError$body2 === void 0 ? void 0 : _apiError$body2.errors.map(function (err) {
            var message = (err === null || err === void 0 ? void 0 : err.detail) || (err === null || err === void 0 ? void 0 : err.message);
            if (/^email is not valid$/i.test(message)) return 'Invalid email address.';
            if (/^email Invalid Domain Name$/i.test(message)) return 'Invalid email domain.';
            if (/^email User already exist$/i.test(message)) {
              return 'A student has already registered with that email. Please contact partnership@applyboard.com for additional information.';
            }
            return message;
          }).join('\n')));
        } else {
          messageDispatch.negative(new Error('We could not connect to the server. Try refreshing the browser window or try again later.'));
        }
        publishAddNewStudentEvent({
          formData: formData,
          errorType: 'api_create',
          trackEvent: trackEvent
        });
        clearDuplicateStudentsList();
      }
    });
  };
  var handleSubmit = function handleSubmit(formData) {
    validateEmail(formData.email, {
      onSuccess: function onSuccess(data) {
        if (data.status) {
          if (isRp) {
            setSubmittedFormValues(formData);
            checkStudentDuplicate({
              personalInformation: {
                firstName: formData.firstName,
                lastName: formData.lastName,
                birthdate: formData.birthDate
              },
              passportNumber: formData.passportNumber
            }, {
              onSuccess: function onSuccess(duplicates) {
                if (duplicates.matchingProfiles.length === 0) {
                  handleAddStudent(formData);
                }
                setDuplicateStudents(duplicates);
              },
              onError: function onError() {
                handleAddStudent(formData);
              }
            });
          } else {
            // Admin workflow - no duplicate student check to form.
            // Just add the student.
            handleAddStudent(formData);
          }
        } else {
          setHasFormError(true);
          messageDispatch.negative(new Error('Invalid email domain detected. Please ensure your email uses a valid domain'));
          trackEvent({
            data: data,
            event: 'ANSM - Email Validation Error Returned',
            group: 'Add New Student Modal'
          });
        }
      },
      onError: function onError() {
        messageDispatch.negative(new Error('We could not connect to the server. Try refreshing the browser window or try again later.'));
      }
    });
  };
  var currentUserAgentInformation = getUserAgentInformation(currentUser);
  var currentUserAgentInformationAttributes = currentUserAgentInformation === null || currentUserAgentInformation === void 0 ? void 0 : currentUserAgentInformation.attributes;
  var isRpSuspended = currentUserAgentInformationAttributes === null || currentUserAgentInformationAttributes === void 0 ? void 0 : currentUserAgentInformationAttributes.suspended;
  if (isRpSuspended) {
    return _jsx(SuspendedRPDialog, {
      isOpen: props.open,
      setIsOpen: props.setShowModal,
      onCloseClick: props.setShowModal,
      title: SUSPENDED_RP_DIALOG_TITLE,
      noticeMessage: SUSPENDED_RP_DIALOG_NOTICE_MESSAGE,
      instruction: SUSPENDED_RP_DIALOG_INSTRUCTION
    });
  }
  return _jsx(FormWrapper, {
    onSubmit: function onSubmit(form) {
      setHasFormError(false);
      handleSubmit(form);
    },
    onFormError: function onFormError(error) {
      setHasFormError(true);
      publishAddNewStudentEvent({
        formErrors: error,
        errorType: 'form',
        trackEvent: trackEvent
      });
    },
    children: _jsx(AddNewStudentModalGroup, {
      open: props.open,
      setShowModal: props.setShowModal,
      isRp: isRp,
      duplicateStudents: duplicateStudents,
      clearDuplicateStudentsList: clearDuplicateStudentsList,
      currentUser: currentUser,
      setHasFormError: setHasFormError,
      hasFormError: hasFormError,
      isSubmittingStudentProfile: isSubmittingStudentProfile,
      submittedFormValues: submittedFormValues,
      handleAddStudent: handleAddStudent
    })
  });
}
var AddNewStudentModalGroup = function AddNewStudentModalGroup(_ref) {
  var open = _ref.open,
    setShowModal = _ref.setShowModal,
    isRp = _ref.isRp,
    duplicateStudents = _ref.duplicateStudents,
    clearDuplicateStudentsList = _ref.clearDuplicateStudentsList,
    currentUser = _ref.currentUser,
    setHasFormError = _ref.setHasFormError,
    hasFormError = _ref.hasFormError,
    isSubmittingStudentProfile = _ref.isSubmittingStudentProfile,
    submittedFormValues = _ref.submittedFormValues,
    handleAddStudent = _ref.handleAddStudent;
  var _useApiDropdownList = useApiDropdownList(),
    leadSourcesDropdownOptions = _useApiDropdownList.leadSourcesDropdownOptions,
    countriesDropdownItems = _useApiDropdownList.countriesDropdownItems;
  var setFieldValues = useSetFieldValues();
  var resetForm = useResetForm();
  var currentUserAgentInformation = getUserAgentInformation(currentUser);
  var currentUserAgentInformationAttributes = currentUserAgentInformation === null || currentUserAgentInformation === void 0 ? void 0 : currentUserAgentInformation.attributes;
  var isRpStaff = currentUserAgentInformationAttributes === null || currentUserAgentInformationAttributes === void 0 ? void 0 : currentUserAgentInformationAttributes.agency_staff;
  var matchingProfiles = useMemo(function () {
    return duplicateStudents === null || duplicateStudents === void 0 ? void 0 : duplicateStudents.matchingProfiles.map(function (profile) {
      return {
        id: profile.userId.toString(),
        email: profile.email,
        avatarUrl: profile.profilePictureUrl,
        fullName: "".concat(profile.firstName || '', " ").concat(profile.lastName || ''),
        canViewProfile: profile.canViewProfile
      };
    });
  }, [duplicateStudents]);
  var hasCheckDuplicateStudents = !!duplicateStudents && duplicateStudents.studentUserIds.length > 0;
  return _jsxs(_Fragment, {
    children: [_jsx(AddNewStudentDialog, {
      isOpen: open && !hasCheckDuplicateStudents,
      setIsOpen: function setIsOpen(open) {
        if (!open) {
          resetForm();
          setHasFormError(false);
          setFieldValues(_objectSpread({}, DEFAULT_FORM_VALUES));
        }
        setShowModal(open);
      },
      countriesOfCitizenshipList: countriesDropdownItems,
      leadStatusList: LEAD_STATUS_OPTIONS,
      leadSourcesList: leadSourcesDropdownOptions,
      isAdmin: !isRp,
      isSubmittingStudentProfile: isSubmittingStudentProfile,
      hasFormError: hasFormError
    }), _jsx(DuplicateStudentWarningDialog, {
      isRP: !isRpStaff // This prop means agency staff!
      ,
      onBackToEditingClick: function onBackToEditingClick() {
        setFieldValues(_objectSpread({}, submittedFormValues));
        clearDuplicateStudentsList();
      },
      isOpen: open && hasCheckDuplicateStudents,
      setIsOpen: setShowModal,
      matchingProfiles: matchingProfiles,
      matchingFields: {
        passportNumber: duplicateStudents !== null && duplicateStudents !== void 0 && duplicateStudents.matchingFields.includes('passport_number') ? submittedFormValues === null || submittedFormValues === void 0 ? void 0 : submittedFormValues.passportNumber : undefined,
        firstName: duplicateStudents !== null && duplicateStudents !== void 0 && duplicateStudents.matchingFields.includes('first_name') ? submittedFormValues === null || submittedFormValues === void 0 ? void 0 : submittedFormValues.firstName : undefined,
        lastName: duplicateStudents !== null && duplicateStudents !== void 0 && duplicateStudents.matchingFields.includes('last_name') ? submittedFormValues === null || submittedFormValues === void 0 ? void 0 : submittedFormValues.lastName : undefined,
        dateOfBirth: duplicateStudents !== null && duplicateStudents !== void 0 && duplicateStudents.matchingFields.includes('birthdate') ? submittedFormValues === null || submittedFormValues === void 0 ? void 0 : submittedFormValues.birthDate.split('T')[0] // Take out the time portion since date picker populates the form value with time as well e.g. 1996-03-22T15:36:10.415Z
        : undefined
      },
      onAddDuplicateStudentClick: function onAddDuplicateStudentClick() {
        return handleAddStudent(submittedFormValues);
      },
      isSubmittingStudentProfile: isSubmittingStudentProfile,
      isUpdatingStudentProfile: false
    })]
  });
};